export const DATABASE_VEHICULE_MANAGER_PAGE = "/main/database/vehicule/manager";
export const DATABASE_VEHICULE_PAGE = "/main/database/vehicule";
export const DATABASE_VEHICULE_FORM = "/main/database/vehicule/nouveau";
export const DATABASE_VEHICULE_EDIT = "/main/database/vehicule/edit/:id";

export const DATABASE_CLIENT_PAGE = "/main/database/client";
export const DATABASE_CLIENT_FORM = "/main/database/client/nouveau";
export const DATABASE_CLIENT_EDIT = "/main/database/client/edit/:id";

export const MODULE_SELECTOR_PAGE = "/modules";
export const MOBILE_DOWNLOAD_PAGE = "/download";

export const PRAMETRAGE_FORM = "/main/parametrage/nouveau";
export const PRAMETRAGE_PAGE = "/main/parametrage";
export const PRAMETRAGE_EDIT = "/main/parametrage/edit/:id";

export const VVINAL_PAGE = "/main/vvinal";

export const ENCHERES_PAGE = "/main/encheres";
export const VHU_LOTS_PAGE = "/main/vhu/lots";
export const VHU_LOT_FORM = "/main/vhu/lots/nouveau";
export const VHU_LOT_EDIT = "/main/vhu/lots/edit/:id";
export const VHU_BID_OFFERS_PAGE = "/main/vhu/offres";
export const FERRAILLEURS_ENCHERES_VISIBLES_PAGE = "/main/ferrailleurs/encheres-visibles";
export const FERRAILLEURS_MES_ACHATS_PAGE = "/main/ferrailleurs/mes-achats";
export const FERRAILLEURS_TERMS_PAGE = "/main/ferrailleurs/termes-conditions";
export const RESEAU_PAGE = "/main/reseau";

export const DASHBOARD_PAGE = "/main/database/vehicule";
